<div class="configurations-container">
  <app-header-actions [headerTitle]="getHeaderTitle() | translate" [headerIcon]="faCog" [config]="headerConfig"
    [initialFilters]="{ searchTerm: searchTerm, selectedTag: '' }"
    [count]="filteredConfigurations.length + ' ' + (getHeaderTitlePlural() | translate)" [showCount]="true"
    (addClick)="openCreateModal()" (backClick)="goBack()"
    (filtersChanged)="onHeaderFiltersChanged($event)"></app-header-actions>

  <div class="content-area">
    <app-item-list [items]="itemsForList" [loading]="loading" [config]="listConfig"
      [hasActiveFilters]="hasActiveFilters" (itemClick)="onItemClick($event)" (actionClick)="onActionClick($event)">
    </app-item-list>
  </div>

  @if (showCreateModal || showEditModal) {
  <app-modal-create-edit [show]="showCreateModal || showEditModal" [isEdit]="showEditModal"
    [title]="showCreateModal ? ('CONFIGURATIONS.CREATE_TITLE' | translate) : ('CONFIGURATIONS.EDIT_TITLE' | translate)"
    [icon]="faCog" [configType]="showEditModal ? (selectedConfiguration?.type || configType) : configType"
    [configuration]="selectedConfiguration" (close)="closeModals()" (updated)="loadConfigurations()">
  </app-modal-create-edit>
  }

  @if (showDeleteModal) {
  <app-modal-delete-confirm [show]="showDeleteModal" [configKey]="selectedConfiguration?.key || ''"
    [configType]="selectedConfiguration?.type || ''" (close)="closeModals()" (confirm)="deleteConfiguration()">
  </app-modal-delete-confirm>
  }

  @if (showDetailsModal) {
  <app-modal-details [show]="showDetailsModal" [configuration]="selectedConfiguration" (close)="closeDetailsModal()">
  </app-modal-details>
  }
</div>